import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';
import Cell from '../Cell';
import { Link } from 'react-router';

import R from 'ramda';
import classNames from 'classnames';
import styles from './card.css';

const { div, h2, header, p, ul, li, span, strong } = hh(h);

const Card = ({
    theme = 'white',
    headerText = '',
    headerImage,
    content = {},
    bodyText = '',
    bodyList = '',
    link = '',
    linkText = 'Read more',
    size,
    badgeText = null,
    children = []
}) => {
    const contentHeadings = Object.keys(content);
    const contentBlock = contentHeadings.map(h => div([
      h === '' ? null : strong({className: styles.bodyHead}, h), // Empty keys means there's no title
      p({className: styles.bodyText}, content[h])
    ]));
    
    const headerStyles = classNames(
        styles.header,
        R.prop(`${theme}Header`, styles),
        {
            [styles.bigSize]: R.equals(size, 'big')
        }
    );
    const headerElement = header({className: headerStyles});
    const difficultyBadge = (badgeText) => span({className: styles.difficultyBadge}, badgeText);
    const headingWithBadge = h2({className: styles.courseHeader}, [
      headerText,
      badgeText ? difficultyBadge(badgeText) : undefined
    ]);
    const linkStyles = classNames(styles.link, R.prop(`${theme}Link`, styles));
    const linkElement = R.isEmpty(link) ? null : h(Link, {to: link, className: linkStyles}, linkText);
    const containedLinkElement = R.isEmpty(link) ? null : div({className: styles.linkContainer}, linkElement);
    const bodyContainerStyles = classNames(styles.body, R.prop(`${theme}Body`, styles));
    const bodyElement = div({className: bodyContainerStyles}, R.reject(R.isNil, [
        div({className: styles.bodyPadding}, [
          headingWithBadge,
          ...contentBlock
        ]),
        containedLinkElement
    ]));

    const card = (body) =>(
        h(Cell, {classes: [styles.cardCell]}, [
            div({className: styles.card}, R.reject(R.isNil, [
                ...children,
                headerElement,
                body]))])
    );

    if (bodyList) {
        const list = ul({className: classNames(styles.list, R.prop(`${theme}Body`, styles))},
                        R.map(
                            (itemText) => li({className: styles.listItem}, itemText),
                            bodyList));

        return card(list);
    }


    return card(bodyElement);
};

Card.propTypes = {
    theme: PropTypes.string,
    size: PropTypes.oneOf(['big']),
    headerText: PropTypes.string.isRequired,
    bodyText: PropTypes.string,
    bodyList: PropTypes.array,
    link: PropTypes.string,
    linkText: PropTypes.string
};

export default Card;



/** WEBPACK FOOTER **
 ** ./src/CourseCard/index.js
 **/